export default "__VITE_ASSET__B$T6lVVv__"